// bdd.js
import { openDB } from 'idb';

const DB_NAME = 'P4C';
const STORE_NAME = 'Shipments';

const initDB = async () => {
    const db = await openDB(DB_NAME, 1, {
        upgrade(db) {
            db.createObjectStore(STORE_NAME, { keyPath: 'DBIndex' });
        },
    });
    return db;
};

export const addItem = async (item) => {
    const db = await initDB();
    await db.put(STORE_NAME, item);
};

export const updateItem = async (item) => {
    const db = await initDB();
    await db.put(STORE_NAME, item);
};

export const getItem = async (id) => {
    const db = await initDB();
    return await db.get(STORE_NAME, id);
};

export const getAllItems = async () => {
    const db = await initDB();
    return await db.getAll(STORE_NAME);
};

export const deleteItem = async (id) => {
    const db = await initDB();
    await db.delete(STORE_NAME, id);
};

export const clearAllItems = async () => {
    const db = await initDB();
    await db.clear(STORE_NAME);
};

export const getAllItemsCount = async () => {
    const db = await initDB();
    return await db.count(STORE_NAME);
};
